import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import "./promo.css";
import Header from "../components/Header";

// Import Swiper React components & Core
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import SwiperCore, { Autoplay } from "swiper/core";

// Khởi tạo Autoplay cho Swiper
SwiperCore.use([Autoplay]);

function Promotion() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [profile, setProfile] = useState(null);
    const [notifyItem, setNotifyItem] = useState();
    const [isShow, setShow] = useState(false);
    
    const navigate = useNavigate();

    // Cấu hình tham số cho Swiper Banner
    const swiperParams = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        loop: true
    };

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
            
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify != res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
    }, []);

   
    return (
        <>
            <Header profile={profile} />
            
            {/* THÊM STYLE CHO GIAO DIỆN KHUYẾN MÃI MỚI */}
            <style>{`
                .promo-page-wrapper {
                    background: #fff;
                    min-height: 100vh;
                }
                .banner-wrapper {
                    width: 100%;
                }
                .banner-wrapper .box-slide img {
                    width: 100%;
                    height: auto;
                    display: block;
                    object-fit: cover;
                }
                
                /* THANH MENU LỌC (Tất cả, Hot, Nạp tiền...) */
                .promo-filter-bar {
                    background: #fff;
                    padding: 20px 0;
                    border-bottom: 1px solid #eee;
                }
                .promo-filter-list {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    gap: 10px;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }
                .promo-filter-item {
                    background: #d32f2f;
                    color: #fff;
                    padding: 8px 20px;
                    font-size: 15px;
                    font-weight: bold;
                    cursor: pointer;
                    transition: 0.3s;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .promo-filter-item:hover,
                .promo-filter-item.active {
                    background: #b71c1c;
                    transform: translateY(-2px);
                }

                /* LƯỚI KHUYẾN MÃI BÊN DƯỚI (2 cột như ảnh) */
                .promo-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 20px;
                    padding: 30px 0;
                }
                @media (max-width: 768px) {
                    .promo-grid { grid-template-columns: 1fr; }
                }
                .box-promo {
                    cursor: pointer;
                    transition: transform 0.3s ease;
                    border-radius: 5px;
                    overflow: hidden;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                }
                .box-promo:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
                }
                .box-promo-img img {
                    width: 100%;
                    height: auto;
                    display: block;
                }
                .box-promo-title {
                    display: none; /* Ẩn title text vì trong ảnh khuyến mãi đã có sẵn text */
                }
            `}</style>

            <section className="promo-page-wrapper">
                {/* 1. KHỐI BANNER SWIPER (Tích hợp code bạn gửi) */}
                <div className="banner-wrapper">
                    {swiperParams && notify ? (
                        <div className="box-slide" style={{ overflow: "hidden" }}>
                            <Swiper {...swiperParams} className="banner-list">
                                {notify.map((item, index) => {
                                    if (index > 1 && item.title !== "marquee" && item.title !== "popup" && item.isShow === true) {
                                        return (
                                            <SwiperSlide key={index}>
                                                <div>
                                                    <img 
                                                        className="carousel-item" 
                                                        alt={item.title.replace("}", "").replace("{", "")} 
                                                        src={item.image} 
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        );
                                    }
                                    return null;
                                })}
                            </Swiper>
                        </div>
                    ) : null}
                </div>


                {/* 3. LƯỚI DANH SÁCH KHUYẾN MÃI BÊN DƯỚI */}
                <div className="container">
                    <div className="promo-grid">
                        {notify && notify.map((item, index) => (
                            <>
                                {/* Chỉ hiện các item là khuyến mãi (bỏ qua banner, marquee, popup) */}
                                {index > 1 && item.title !== "marquee" && item.title !== "popup" && item.isShow === true ? (
                                    <div
                                        className="box-promo"
                                        key={index}
                                        onClick={() => {
                                            if (item.title.indexOf("{") !== 0) {
                                                setNotifyItem(item);
                                                setShow(true);
                                            } else {
                                                navigate(item.content.replace(/<\/?[^>]+(>|$)/g, ""));
                                            }
                                        }}
                                    >
                                        <div className="box-promo-img">
                                            <img alt={item.title.replace("}", "").replace("{", "")} src={item.image} />
                                        </div>
                                        {/* Bạn có thể bỏ comment dòng dưới nếu muốn hiển thị chữ tiêu đề */}
                                        {/* <div className="box-promo-title">{item.title.replace("}", "").replace("{", "")}</div> */}
                                    </div>
                                ) : null}
                            </>
                        ))}
                    </div>
                </div>
            </section>

            {/* 4. POPUP HIỂN THỊ CHI TIẾT KHUYẾN MÃI KHI CLICK */}
            {notifyItem != null && isShow ? (
                <div className="popup-backdrop" style={{ zIndex: 9999 }}>
                    <div className="popup-main" style={{ maxWidth: '800px', width: '95%' }}>
                        <div className="popup-header" style={{ background: '#d32f2f', color: '#fff' }}>
                            {notifyItem.title.replace("}", "").replace("{", "")}
                        </div>
                        <div className="popup-content" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            {notifyItem.content.indexOf("{") != -1 && notifyItem.content.indexOf("}") != -1 ? (
                                <>
                                    <img
                                        src={notifyItem.content.substring(notifyItem.content.indexOf("{") + 1, notifyItem.content.indexOf("}"))}
                                        style={{ width: "100%", height: "auto", marginBottom: '15px' }}
                                        alt="Promo Detail"
                                    />
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: notifyItem.content.replace(
                                                notifyItem.content.substring(notifyItem.content.indexOf("{"), notifyItem.content.indexOf("}") + 1),
                                                ""
                                            )
                                        }}
                                    />
                                </>
                            ) : (
                                <div dangerouslySetInnerHTML={{ __html: notifyItem.content }} />
                            )}
                        </div>
                        <button onClick={() => setShow(false)} className="popup-close" style={{ background: '#333', color: '#fff', width: '100%', padding: '12px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>
                            Đóng
                        </button>
                    </div>
                </div>
            ) : null}
        </>
    );
}

export default Promotion;